angular.module('natgeo').factory('UserProgress', 
function UserProgress()
{
	/**
	 * User Progress and related settings
	 */
	var UserProgress = {
		
		// Level 2 & 5

		Colors: {
			/** Body Colors */
			Gray: 	{r:114, g:123, b:126},
			Blue: 	{r: 29, g:153, b:223},
			Orange: {r:232, g:147, b:  7},
			/** Wheel Colors */
			White:  {r:210, g:230, b:255},
			Purple: {r:120, g: 97, b:174},
			Green:  {r:141, g:175, b: 43}	
		},

		BodyColors: [
			'Gray',
			'Blue',
			'Orange'
		],

		WheelColors: [
			'White',
			'Purple',
			'Green'
		],
		
		CurrentBodyColor: function()
		{
			return UserProgress.Colors[ UserProgress.CurrentBodyColorName() ];
		},

		CurrentBodyColorName: function()
		{
			return UserProgress.BodyColors[ UserProgress.BodyColor ];
		},
		
		CurrentWheelColor: function()
		{
			return UserProgress.Colors[ UserProgress.CurrentWheelColorName() ];
		},
		
		CurrentWheelColorName: function()
		{
			return UserProgress.WheelColors[ UserProgress.WheelColor ];
		},

		GetBodyColor: function(colorName)
		{
			return jQuery.inArray( colorName, UserProgress.BodyColors );
		},

		GetWheelColor: function(colorName)
		{
			return jQuery.inArray( colorName, UserProgress.WheelColors );
		},

		// Level 3

		BeePower: 0,

		BeeSensor: 0,

		BeeWeight: 0,

		BeeCanPollinate: true,

		// Level 4

		SubmarineBodies: {
			Cylinder: 0,
			Rectangle: 1
		},

		SubmarineMotors: {
			Propeller: 0,
			Hybrid: 1
		},

		SubmarineSensors: {
			Sonar: 0,
			Camera: 1
		},

		SubmarineEffectors: {
			Magnet: 0,
			Arm: 1,
			Net: 2
		},

		SubmarineControllers: {
			Serpentine: 0,
			Straight: 1,
			Random: 2
		},

		SubmarineBody: null,

		SubmarineMotor: null,

		SubmarineSensor: null,

		SubmarineEffector: null,

		SubmarineController: null,

		// Level 5

		ExplorerRetrievals: {
			Claw: 0,
			Broom: 1,
			Shovel: 2
		},

		ExplorerLights: {
			Light: 0,
			LED: 1,
			Reflector: 2
		},

		ExplorerRetrieval: null,

		ExplorerLight: null,

		// Current Progress
		Level1: 0,
		Level2: 0,
		Level3: 0,
		Level4: 0,
		Level5: 0,
		BodyColor: 0,
		WheelColor: 0,

		/**
		 * Saves the current passcode to local storage.
		 */
		savePasscode: function()
		{
			var passcode = this.getPasscode();

			if ( Fullscreen.is() && window.localStorage )
			{
				localStorage.setItem( 'passcode', passcode );
			}
		},

		/**
		 * Loads a passcode from local storage.
		 */
		loadPasscode: function()
		{
			if ( Fullscreen.is() && window.localStorage )
			{
				var passcode = localStorage.getItem( 'passcode' );

				if ( passcode )
				{
					this.setPasscode( passcode );
				}
			}
		},

		/**
		 * Returns the passcode according to what the current user has achieved.
		 */
		getPasscode: function()
		{
			var levelsIndex = 
				UserProgress.Level1 * 1 + 
				UserProgress.Level2 * 2 + 
				UserProgress.Level3 * 4 + 
				UserProgress.Level4 * 8 + 
				UserProgress.Level5 * 16;

			var colorIndex = 
				UserProgress.BodyColor * 1 + 
				UserProgress.WheelColor * 3 + 1;

			// No Progress
			if ( levelsIndex === 0 )
			{
				return 'No Progress';
			}

			return UserProgress.passcodes[ levelsIndex ] + colorIndex;
		},

		/**
		 * Sets the passcode according to what the current user has achieved.
		 */
		setPasscode: function(passcode)
		{
			var colors = passcode.charAt( passcode.length - 1 );
			var colorIndex = parseInt( colors );

			if (isNaN(colorIndex))
			{
				return false;
			}

			colorIndex -= 1;

			var levels = passcode.substring( 0, passcode.length - 1 ).toLowerCase();
			var levelsIndex = jQuery.inArray( levels, UserProgress.passcodes );

			if (levelsIndex === -1)
			{
				return false;
			}

			// No Progress
			if ( levelsIndex === 0 )
			{
				return false;
			}

			UserProgress.Level1 = levelsIndex & 1; levelsIndex >>= 1;
			UserProgress.Level2 = levelsIndex & 1; levelsIndex >>= 1;
			UserProgress.Level3 = levelsIndex & 1; levelsIndex >>= 1;
			UserProgress.Level4 = levelsIndex & 1; levelsIndex >>= 1;
			UserProgress.Level5 = levelsIndex & 1; levelsIndex >>= 1;

			UserProgress.BodyColor = colorIndex % 3;
			UserProgress.WheelColor = Math.floor( colorIndex / 3 ) % 3;

			return true;
		},

		// Array of all passcodes
		passcodes: [
			'motor', // unused because 'No Progress'
			'effector',
			'sensor',
			'power',
			'battery',
			'machine',
			'program',
			'processor',
			'antenna',
			'wheel',
			'controller',
			'command',
			'action',
			'robotic',
			'computer',
			'hybrid',
			'weight',
			'camera',
			'gyroscope',
			'ocelli',
			'magnet',
			'micronet',
			'body',
			'sonar',
			'arm',
			'causeway',
			'pyramid',
			'light',
			'artifact',
			'action',
			'tunnel',
			'explorer'
		]
		
	};
	
	/*
	for (var i = 0; i < UserProgress.passcodes.length; i++)
	{
		var code = UserProgress.passcodes[ i ];

		var x = i;
		var b1 = x & 1; x >>= 1;
		var b2 = x & 1; x >>= 1;
		var b3 = x & 1; x >>= 1;
		var b4 = x & 1; x >>= 1;
		var b5 = x & 1; x >>= 1;

		console.log( '' + b1 + b2 + b3 + b4 + b5 + ' = ' + code );
	}
	*/

	return UserProgress;
	
});